  window.onload = function () {


      var allContent = document.getElementsByClassName('set-content')
      if (allContent.length != 0) {

        for (var i = 0; i < allContent.length; i++) {
          allContent[i].style.display = 'none'
        }
        allContent[0].style.display = 'block'
      }



      var newlist = document.getElementsByClassName('grid-product__content')
      for (var i = 0; i < newlist.length; i++) {
        if (newlist[i].getElementsByClassName('grid-product__tag grid-product__tag--sale')[0] != undefined) {
          newlist[i].getElementsByClassName('grid-product__tag grid-product__tag--sale')[0].innerHTML = newlist[i].getElementsByTagName('a')[0].getElementsByClassName('grid-product__price')[0].getElementsByClassName('grid-product__price--savings')[0].innerHTML

        }
        newlist[i].getElementsByTagName('a')[0].getElementsByClassName('grid-product__price')[0].getElementsByClassName('grid-product__price--savings')[0].hidden = 'hidden'

      }

    }

    function toggleStatus(obj) {
      var allContent = document.getElementsByClassName('set-content')
      for (var i = 0; i < allContent.length; i++) {
        if (allContent[i].getAttribute('data-toggle') == obj.getAttribute("data-toggle")) {
          if (allContent[i].style.display == 'block') {
            allContent[i].style.display = 'none'
            obj.childNodes[1].style.display = 'block';
            obj.childNodes[3].style.display = 'none';
          } else {
            allContent[i].style.display = 'block'
            obj.childNodes[1].style.display = 'none';
            obj.childNodes[3].style.display = 'block';
          }
        }
      }
    }

/* KUOSER color swatch image preview: hover/touch immediately swaps the card image. */
(function(){
  function swapProductImage(swatch, card){
    var url = swatch.getAttribute('data-variant-image');
    if(!url || !card) return;
    var media = card.querySelector('.grid-product__image-mask');
    if(!media) return;
    var bg = media.querySelector('.grid__image-ratio');
    var img = media.querySelector('img.grid-product__image');
    if(bg){
      if(!bg.dataset.kuoserOriginalBg) bg.dataset.kuoserOriginalBg = bg.style.backgroundImage || '';
      bg.style.backgroundImage = 'url("'+url+'")';
      bg.classList.add('kuoser-color-preview-active');
    } else if(img){
      if(!img.dataset.kuoserOriginalSrc) img.dataset.kuoserOriginalSrc = img.currentSrc || img.src || img.getAttribute('src') || '';
      img.src = url;
      img.removeAttribute('srcset');
      img.classList.add('kuoser-color-preview-active');
    }
  }
  function restoreProductImage(card){
    var media = card && card.querySelector('.grid-product__image-mask');
    if(!media) return;
    var bg = media.querySelector('.grid__image-ratio');
    var img = media.querySelector('img.grid-product__image');
    if(bg && bg.dataset.kuoserOriginalBg !== undefined){ bg.style.backgroundImage = bg.dataset.kuoserOriginalBg; }
    if(img && img.dataset.kuoserOriginalSrc){ img.src = img.dataset.kuoserOriginalSrc; }
  }
  function bind(){
    document.querySelectorAll('[data-kuoser-color-swatches] .color-swatch[data-variant-image]').forEach(function(swatch){
      if(swatch.dataset.kuoserPreviewBound==='1') return;
      swatch.dataset.kuoserPreviewBound='1';
      var card=swatch.closest('.grid-product');
      swatch.addEventListener('mouseenter',function(){ swapProductImage(swatch,card); });
      swatch.addEventListener('focus',function(){ swapProductImage(swatch,card); });
      swatch.addEventListener('mouseleave',function(){ restoreProductImage(card); });
      swatch.addEventListener('blur',function(){ restoreProductImage(card); });
      swatch.addEventListener('touchstart',function(){ swapProductImage(swatch,card); },{passive:true});
    });
    document.querySelectorAll('.grid-product').forEach(function(card){
      if(card.dataset.kuoserCardBound==='1') return;
      card.dataset.kuoserCardBound='1';
      card.addEventListener('mouseleave',function(){ restoreProductImage(card); });
    });
  }
  document.addEventListener('DOMContentLoaded',bind);
  document.addEventListener('shopify:section:load',bind);
  window.setTimeout(bind,800);
})();

(function(){
  function bind(){
    document.querySelectorAll('[data-kuoser-color-swatches] .color-swatch[data-variant-image]').forEach(function(sw){
      if(sw.dataset.kuoserStrictBound) return; sw.dataset.kuoserStrictBound='1';
      var card=sw.closest('.grid-product'); if(!card) return;
      var img=card.querySelector('.grid-product__image');
      var bg=card.querySelector('.grid__image-ratio');
      function show(){var u=sw.dataset.variantImage;if(!u)return;if(img){if(!img.dataset.kuoserSrc)img.dataset.kuoserSrc=img.getAttribute('src')||img.getAttribute('data-src')||'';img.src=u;img.removeAttribute('data-src');}if(bg){if(!bg.dataset.kuoserBg)bg.dataset.kuoserBg=bg.style.backgroundImage||'';bg.style.backgroundImage='url('+u+')';}}
      function restore(){if(img&&img.dataset.kuoserSrc){img.src=img.dataset.kuoserSrc;}if(bg&&bg.dataset.kuoserBg!==undefined){bg.style.backgroundImage=bg.dataset.kuoserBg;}}
      sw.addEventListener('mouseenter',show);sw.addEventListener('focus',show);sw.addEventListener('mouseleave',restore);sw.addEventListener('blur',restore);sw.addEventListener('touchstart',function(e){e.preventDefault();show();},{passive:false});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind);else bind();document.addEventListener('shopify:section:load',bind);
})();
